export default {
  name: 'migration',
  signature: '[COMMAND]',
  isGroupRoot: true,
  description: 'Manages content migrations for Content Lake datasets',
}
